const isCallState = (state) => state === "call" || state === "partial-call" || state === "input-streaming" || state === "input-available";
const isOutputState = (state) => state === "result" || state === "output-available" || state === "output" || state === "complete";
function normalizeDynamoValue(value) {
  if (value === null || value === void 0) return value;
  if (typeof value !== "object") return value;
  if (Array.isArray(value)) return value.map((item) => normalizeDynamoValue(item));
  if ("value" in value && Object.keys(value).length === 1) {
    return normalizeDynamoValue(value.value);
  }
  const normalized = {};
  for (const key of Object.keys(value)) {
    normalized[key] = normalizeDynamoValue(value[key]);
  }
  return normalized;
}
export {
  isCallState,
  isOutputState,
  normalizeDynamoValue
};
//# sourceMappingURL=types.js.map
